// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2yN_V","ft_p":"Footer_ft_p__128Nj"};